export default "__VITE_ASSET__BC_dd70T__"